

















import { Prop, Component, Vue } from 'vue-property-decorator'
import Icon from '../../shared/Icon/Icon.vue'
import { ButtonMode, ButtonSize, ButtonType } from '../../../types/interfaces'
import 'vue-router'

@Component({ components: { Icon } })
export default class Button extends Vue {
  @Prop({ default: 'primary' }) readonly mode!: ButtonMode;
  @Prop({ default: 'normal' }) readonly size!: ButtonSize;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly iconName?: string | false;
  @Prop({ default: null }) readonly tooltip!: string | boolean | object | null
  @Prop({ default: null }) readonly type!: ButtonType | null
  @Prop({ default: 'button' }) readonly tag!: string
  @Prop({ default: null }) readonly target!: string | null

  click (event: MouseEvent) {
    if (this.disabled || this.loading) {
      return
    }
    if (this.tag === 'a' && this.target !== '_blank' && this.$attrs.href) {
      event.preventDefault()
      this.$router.push(this.$attrs.href)
    }
    this.$emit('click', event)
  }
}
